import { render, staticRenderFns } from "./device-group-tree.vue?vue&type=template&id=5f672b8c&scoped=true&"
import script from "./device-group-tree.vue?vue&type=script&lang=js&"
export * from "./device-group-tree.vue?vue&type=script&lang=js&"
import style0 from "./device-group-tree.vue?vue&type=style&index=0&id=5f672b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f672b8c",
  null
  
)

export default component.exports